import career from './career';
import caregiver from './caregiver';
import client from './client';
import family from './family';
import job from './job';
import loomLead from './loom_lead';
import schedule from './schedule';

export default {
  career,
  caregiver,
  client,
  family,
  job,
  loomLead,
  schedule,
};
